import {FuseNavigation} from '@fuse/types';

export const multiFranchiseAdminNavigation: FuseNavigation[] = [
    {
        id: 'multi-franchise-management',
        title: 'Multi Franchise Management',
        translate: 'Multi Franchise Management',
        type: 'group',
        children: [
            {
                id: 'customers',
                title: 'Customers',
                translate: 'Customers Search',
                type: 'item',
                icon: 'group',
                url: '/multi-franchise/customers'
            }
        ]
    }
];
